import { useEffect, useState, useRef } from "react";
import Howtoplay from "../Components/Howtoplay";
import HowtoplayMob from "../Components/HowtoplayMob";
import useDeviceType from "../Utiles/FindDevice";
import { tinyV } from "../assets";
import { pnpLogo } from "../Asserts";
import { useNavigate } from "react-router";
import Footer from "../Components/Footer";
import { FooterTab, MobileFooter } from "../../Components/GreenHome/Footer";
import Navbar from "./RoundToJoin/navbar";
import Player from "@vimeo/player";

const HowToPlayHome = () => {
  const deviceType = useDeviceType();
  const [showVideoModal, setShowVideoModal] = useState(false);
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const [selectedNav, setSelectedNav] = useState("How to Play");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [otherMenusOpen, setOtherMenusOpen] = useState(false);
  const [dropdownPos, setDropdownPos] = useState({});
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleVideoClick = () => {
    setShowVideoModal(true);
  };

  const closeVideoModal = () => {
    setShowVideoModal(false);
  };

  const handleModalClick = (e) => {
    if (e.target === e.currentTarget) {
      closeVideoModal();
    }
  };

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && showVideoModal) {
        closeVideoModal();
      }
    };

    if (showVideoModal) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [showVideoModal]);

  return (
    <div
      className="min-h-screen w-full bg-cover bg-center bg-no-repeat overflow-hidden"
      style={{
        backgroundImage:
          deviceType === "mobile"
            ? "url('v2/images/bg/auth-bg-mobile.png')"
            : "url('/v2/images/bg/auth-bg.png')",
      }}
    >
      <Navbar
        setDropdownOpen={setDropdownOpen}
        setSelectedNav={setSelectedNav}
        selectedNav={selectedNav}
        setMobileMenuOpen={setMobileMenuOpen}
        setDropdownPos={setDropdownPos}
        dropdownPos={dropdownPos}
        dropdownOpen={dropdownOpen}
        mobileMenuOpen={mobileMenuOpen}
        setOtherMenusOpen={setOtherMenusOpen}
        otherMenusOpen={otherMenusOpen}
      />
      <div className="pt-16">
        {/* Scrollable Navigation Sub-Bar */}
        <div className="w-full bg-gradient-to-r from-[#007FFF] to-[#00C05B] py-4 px-2.5 overflow-x-auto scrollbar-hide">
          <div className="flex items-center gap-2 px-2 sm:px-4 min-w-min whitespace-nowrap">
            <button
              className="px-3 py-1.5 rounded-full font-archivo font-semibold text-xs md:text-[14px] bg-white text-black"
            >
              How to Play
            </button>
          </div>
        </div>

        <style jsx>{`
          .scrollbar-hide::-webkit-scrollbar {
            display: none;
          }
          .scrollbar-hide {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
        `}</style>

      </div>
      <h1 className="text-[16px] md:text-xl lg:text-2xl font-archivo font-semibold text-center text-white pt-6">
        How To Play
      </h1>
    
      <div className="pb-4">
        <div className="flex items-center justify-center min-h-screen p-4 md:p-2">
          {deviceType === "mobile" ? <HowtoplayMob /> : <Howtoplay />}
        </div>
        <section className="w-full mt-2 md:mt-0">
          <div
            className="flex flex-col lg:flex-row lg:justify-between lg:px-6 lg:items-center rounded-lg sm:flex-col sm:justify-center sm:py-2 sm:px-4 w-[90%] mx-auto px-4 md:px-6 py-3 lg:py-4"
            style={{
              background: "linear-gradient(90deg, #0B2A47 0%, #1B66AD 100%)",
            }}
          >
            <div className="flex-1 flex flex-col justify-center lg:items-start items-center text-center lg:text-left w-[100%]">
              <h4 className="laptop-l-min:text-start lg:text-[18px] font-[600] text-[#FAFAFA] -tracking-[.5px] font-archivo w-full lg:text-left text-center">
                <span className="block sm:inline">Watch & Learn:</span>
                <span className="block sm:inline sm:ml-1">
                  Full Game Walkthrough →
                </span>
              </h4>
              {deviceType === "mobile" ? (
                <section>
                  <h6 className="laptop-l-min:text-start laptop-min:text-start laptop-l-min:mt-3 laptop-min:mt-2 mt-2 laptop-min:w-[100%] laptop-l-min:text-[22px] laptop-l-min:text-[13px] leading-[20px] font-[400] text-[#FFFFFF99] -tracking-[.5px] font-inter w-full lg:text-left text-center text-[14px]">
                    This video breaks down everything -{" "}
                  </h6>
                  <h6 className="laptop-l-min:text-start laptop-min:text-start laptop-l-min:mt-3 laptop-min:mt-2 laptop-min:w-[100%] laptop-l-min:text-[22px] laptop-l-min:text-[13px] leading-[20px] font-[400] text-[#FFFFFF99] -tracking-[.5px] font-inter w-full lg:text-left text-center text-[14px]">
                    {" "}
                    from rules to rewards!
                  </h6>
                </section>
              ) : (
                <>
                  <h6 className="laptop-l-min:text-start laptop-min:text-start laptop-l-min:mt-3 laptop-min:mt-2 mt-2 laptop-min:w-[100%] laptop-l-min:text-[22px] laptop-l-min:text-[13px] leading-[20px] font-[400] text-[#FFFFFF99] -tracking-[.5px] font-inter w-full lg:text-left text-center text-[16px]">
                    This video breaks down everything - from rules to rewards!
                  </h6>
                </>
              )}
            </div>
            <div className="w-full flex justify-center items-center lg:w-auto lg:block mt-3 lg:mt-0">
              <img
                src={tinyV}
                className="w-full max-w-[280px] px-4 md:px-0 rounded-lg hover:opacity-90 transition-opacity duration-300 cursor-pointer"
                style={{ objectFit: "cover" }}
                alt="Watch & Learn video preview"
                onClick={handleVideoClick}
              />
            </div>
          </div>
        </section>
      </div>
      {showVideoModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[200] p-4 sm:p-6 md:p-8"
          onClick={handleModalClick}
        >
          <div className="relative w-full max-w-4xl">
            {/* Close button with dark gray background and smaller size */}
            <button
              className="absolute -top-4 -right-4 text-white hover:text-gray-300 z-10 bg-gray-800 hover:bg-gray-900 rounded-full p-1 transition-all duration-200 shadow-lg"
              onClick={closeVideoModal}
              aria-label="Close video"
            >
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            {/* Video container */}
            <div className="bg-black rounded-lg overflow-hidden shadow-2xl">
              {/* Vimeo embed container */}
              <div
                className="relative w-full"
                style={{ paddingBottom: "56.25%" /* 16:9 aspect ratio */ }}
              >
                <iframe
                  ref={videoRef}
                  className="absolute top-0 left-0 w-full h-full"
                  src="https://player.vimeo.com/video/1144877092?badge=0&autopause=0&quality_selector=1&player_id=0&app_id=58479&autoplay=1"
                  title="Watch & Learn: Full Game Walkthrough"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      )}
      <>
       {deviceType === "mobile" ?
        <MobileFooter /> :
        <FooterTab componnent="rules" />
       }
      </>
    </div>
  );
};

export default HowToPlayHome;